/**
 * Centro Terapéutico Cubic RESTFull API
 * Centro Terapéutico Cubic Endpoints
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CreateEventsDto } from '../../models/api/CreateEventsDto';
// @ts-ignore
import { Event } from '../../models/api/Event';
// @ts-ignore
import { FilterEventsDto } from '../../models/api/FilterEventsDto';
// @ts-ignore
import { UpdateEventsDto } from '../../models/api/UpdateEventsDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class EventsService {


  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;
  protected basePath = 'http://localhost';


    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    public addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === 'object' && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    public addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error('key may not be null if value is Date');
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error('key may not be null if value is not object or array');
        }
        return httpParams;
    }

    /**
     * @param updateEventsDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerBulkUpdate(updateEventsDto: Array<UpdateEventsDto>, observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
    }): Observable<any>;
    public eventsControllerBulkUpdate(updateEventsDto: Array<UpdateEventsDto>, observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
    }): Observable<HttpResponse<any>>;
    public eventsControllerBulkUpdate(updateEventsDto: Array<UpdateEventsDto>, observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
    }): Observable<HttpEvent<any>>;
    public eventsControllerBulkUpdate(updateEventsDto: Array<UpdateEventsDto>, observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
    }): Observable<any> {
        if (updateEventsDto === null || updateEventsDto === undefined) {
            throw new Error('Required parameter updateEventsDto was null or undefined when calling eventsControllerBulkUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = '/events';
        return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateEventsDto,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param createEventsDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerCreate(createEventsDto: CreateEventsDto, observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<string>;
    public eventsControllerCreate(createEventsDto: CreateEventsDto, observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    public eventsControllerCreate(createEventsDto: CreateEventsDto, observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    public eventsControllerCreate(createEventsDto: CreateEventsDto, observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<any> {
        if (createEventsDto === null || createEventsDto === undefined) {
            throw new Error('Required parameter createEventsDto was null or undefined when calling eventsControllerCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = '/events';
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createEventsDto,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerFindAll(observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<Array<Event>>;
    public eventsControllerFindAll(observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpResponse<Array<Event>>>;
    public eventsControllerFindAll(observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpEvent<Array<Event>>>;
    public eventsControllerFindAll(observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = '/events';
        return this.httpClient.request<Array<Event>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerFindOne(id: string, observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<Event>;
    public eventsControllerFindOne(id: string, observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpResponse<Event>>;
    public eventsControllerFindOne(id: string, observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpEvent<Event>>;
    public eventsControllerFindOne(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling eventsControllerFindOne.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/events/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
        return this.httpClient.request<Event>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param filterEventsDto
     * @param sort
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerFindWithFilter(filterEventsDto: FilterEventsDto, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<Array<Event>>;
    public eventsControllerFindWithFilter(filterEventsDto: FilterEventsDto, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpResponse<Array<Event>>>;
    public eventsControllerFindWithFilter(filterEventsDto: FilterEventsDto, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpEvent<Array<Event>>>;
    public eventsControllerFindWithFilter(filterEventsDto: FilterEventsDto, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<any> {
        if (filterEventsDto === null || filterEventsDto === undefined) {
            throw new Error('Required parameter filterEventsDto was null or undefined when calling eventsControllerFindWithFilter.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = '/events/filter';
        return this.httpClient.request<Array<Event>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: filterEventsDto,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerRemove(id: string, observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<string>;
    public eventsControllerRemove(id: string, observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    public eventsControllerRemove(id: string, observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    public eventsControllerRemove(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling eventsControllerRemove.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/events/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
        return this.httpClient.request<string>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id
     * @param updateEventsDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eventsControllerUpdate(id: string, updateEventsDto: UpdateEventsDto, observe?: 'body', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<string>;
    public eventsControllerUpdate(id: string, updateEventsDto: UpdateEventsDto, observe?: 'response', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpResponse<string>>;
    public eventsControllerUpdate(id: string, updateEventsDto: UpdateEventsDto, observe?: 'events', reportProgress?: boolean, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<HttpEvent<string>>;
    public eventsControllerUpdate(id: string, updateEventsDto: UpdateEventsDto, observe: any = 'body', reportProgress: boolean = false, options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
    }): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling eventsControllerUpdate.');
        }
        if (updateEventsDto === null || updateEventsDto === undefined) {
            throw new Error('Required parameter updateEventsDto was null or undefined when calling eventsControllerUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarCredential: string | undefined = this.configuration.lookupCredential('bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/events/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
        return this.httpClient.request<string>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateEventsDto,
                responseType: responseType_ as any,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
